import Invoice2Container from "../../../../../Components/Applications/Ecommerce/Invoice/Invoice2/Invoice2Container";

const Invoice2 = () => {
  return <Invoice2Container />;
};

export default Invoice2;
